import _ from "lodash"
class Criteo {
  initDone = false;
  lastParams = null;
  init() {
    if (!this.initDone) {
      window.criteo_q = window.criteo_q || [];
      const deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
      window.criteo_q.push(
        { event: "setAccount", account: 5618 },
        { event: "setSiteType", type: deviceType }
      );
      this.initDone = true;
    }
  }
  sendEvent(params) {
    if (!_.isEqual(this.lastParams, params)) {
      this.lastParams = Object.assign({}, params);
      this.init();
      window.criteo_q.push(params);
    }
  }
}
const criteo = new Criteo();
export default criteo;



// WEBPACK FOOTER //
// ./lib/criteo.js